// 轴线
import store from "@/store";
import {
  addEntityToDrawing,
  getEntityData,
  calculateDistanceAndAngle,
  enableSnapCorrection,
} from "@/rlMxModules/operate/operateApi";
import {
  rlTextData,
  rlCircleData,
  rlLineData,
  rlJointData,
  rlGridData,
} from "@/rlMxModules/rlDataClass/index";
import { fixOrthogonal } from "@/rlMxModules/utils/util";
import { resetRlModules } from "@/mixins/LiteModuleDb.js";
import rlBaseData from "./rlBaseData";
import mxcad from "mxcad";
const { McDbLine, McCmColor, McDbText, McGePoint3d, McDbCircle, McDbPolyline } =
  mxcad;
import { MxCpp } from "mxcad";
import {
  getInputElement,
  createInputElement,
  setInputElementPosition,
  setCurrDataObj,
  setContainerShow,
} from "@/rlMxModules/operate/inputElement.js";
import { isMobileDevice } from "@/utils/matchMedia";

class rlAxisData extends rlBaseData {
  constructor() {
    super();

    this.points = []; // 顶点列表
    this.m_stJoint = null; // 起点节点
    this.m_edJoint = null; // 终点节点

    this.Name = ""; // 轴线名称
    this.IsMainAxis = 0; // 是否是主轴

    this._threeObj = null; // 三维图形对象
    // this.defaultColor = new THREE.Color(0xffffff); //默认颜色
    this.Color = null; // 构件颜色
    this.lineWidth = 0; // 线宽

    this.classTypeName = "rlAxis"; // 轴线

    this.m_gridIds = new Array(); // 轴线上的网格集合
    this.m_groupName = "rlLineAxisGroup";
    this.mcDbAxis = new McDbLine(); // 轴线
    this.mcDbId = null; // 轴线ID
    this.textDistanceId = null; // 轴线距离文本ID
    this.textAngleId = null; // 轴线角度文本ID

    this.m_axisLineStPt = null; //轴线命名绘制数据的起点
    this.m_axisLineEdPt = null; //轴线命名绘制数据的终点

    // 轴线命名数据
    this.m_stText = null;
    this.m_edText = null;

    // 轴线命名辅助直线
    this.m_stLineTmp = null;
    // this.m_stLineTmpId = null;

    // 轴线命名辅助直线
    this.m_edLineTmp = null;
    // this.m_edLineTmpId = null;

    this.m_stCircle = null;
    // this.m_stCircleId = null;

    this.m_edCircle = null;
    // this.m_edCircleId = null;

    // this.lineObjId = -1;
    this.m_TextObj = null;
    this.isShow = "1"; //是否显示
  }

  initData(obj) {
    // 合理性校验
    if (!obj.m_stJoint || !obj.m_edJoint) {
      this.erase();
      return;
    }

    super.initData(obj);
    if (this.mcDbId) {
      this.mcDbAxis = this.mcDbId.getMcDbEntity();
    }
    this.m_stJoint = obj.m_stJoint;
    this.m_edJoint = obj.m_edJoint;

    this.Name = obj.Name == "" || obj.Name == undefined ? "" : obj.Name;
    this.IsMainAxis = obj.IsMainAxis ? obj.IsMainAxis : 0;
    this.mcDbAxis.startPoint = new McGePoint3d(
      obj.m_stJoint.m_pt[0],
      obj.m_stJoint.m_pt[1],
      obj.m_stJoint.m_pt[2]
    );
    this.mcDbAxis.endPoint = new McGePoint3d(
      obj.m_edJoint.m_pt[0],
      obj.m_edJoint.m_pt[1],
      obj.m_edJoint.m_pt[2]
    );
    // let numVerts = this.mcDbAxis.numVerts() - 1;
    // for (let i = numVerts; i >= 0; i--) {
    //   this.mcDbAxis.removeVertexAt(i);
    // }
    // this.mcDbAxis.addVertexAt(this.mcDbAxis.startPoint);
    // this.mcDbAxis.addVertexAt(this.mcDbAxis.endPoint);

    this.points = [
      new THREE.Vector3(...this.m_stJoint.m_pt),
      new THREE.Vector3(...this.m_edJoint.m_pt),
    ];

    // 将数据和图形绑定
    this.mcDbAxis.setxDataString("Guid", this.Guid);
    this.mcDbAxis.setxDataString("classTypeName", this.classTypeName);
    // this.mcDbAxis.visible = store.state.displayData.axisDisplay;
    if (obj.isShow) {
      this.isShow = obj.isShow;
    }
  }

  draw() {
    // 节点数据绑定
    // if (this.m_stJoint) {
    //   if (!this.m_stJoint.m_AxisIds.includes(this.Guid)) {
    //     this.m_stJoint.m_AxisIds.push(this.Guid);
    //   }
    // }
    // if (this.m_edJoint) {
    //   if (!this.m_edJoint.m_AxisIds.includes(this.Guid)) {
    //     this.m_edJoint.m_AxisIds.push(this.Guid);
    //   }
    // }
    // this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbAxis);
    // this.drawTextTest();
  }

  // 生成轴线
  setPoints(s, e) {
    this.points = [s, e];
  }

  // 克隆
  myClone() {
    const newObj = new rlAxisData();
    newObj.m_stJoint = this.m_stJoint.myClone();
    newObj.m_edJoint = this.m_edJoint.myClone();
    newObj.m_Axis = null;
    newObj.StdFlrGuid = this.StdFlrGuid;
    newObj.mcDbGrid = this.mcDbGrid;
    newObj.mcDbGrid.startPoint = new McGePoint3d(
      newObj.m_stJoint.m_pt[0],
      newObj.m_stJoint.m_pt[1],
      newObj.m_stJoint.m_pt[2]
    );
    newObj.mcDbGrid.endPoint = new McGePoint3d(
      newObj.m_edJoint.m_pt[0],
      newObj.m_edJoint.m_pt[1],
      newObj.m_edJoint.m_pt[2]
    );

    // newObj.mcDbGrid.addVertexAt(newObj.mcDbGrid.startPoint);
    // newObj.mcDbGrid.addVertexAt(newObj.mcDbGrid.endPoint);

    newObj.Color = this.Color;
    newObj.mcDbGrid.setxDataString("Guid", newObj.Guid);
    newObj.mcDbGrid.setxDataString("classTypeName", newObj.classTypeName);
    // newObj.mcDbAxis.visible = store.state.displayData.axisDisplay;
    return newObj;
  }

  // 用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_stJoint = getEntityData({
      classTypeName: "rlJoint",
      Guid: obj.m_stJoint,
    });
    this.m_edJoint = getEntityData({
      classTypeName: "rlJoint",
      Guid: obj.m_edJoint,
    });

    this.Name = obj.Name == "" || obj.Name == undefined ? "" : obj.Name;
    this.IsMainAxis = obj.IsMainAxis;

    this.points = [
      new THREE.Vector3(...this.m_stJoint.m_pt),
      new THREE.Vector3(...this.m_edJoint.m_pt),
    ];

    this.mcDbAxis.startPoint = new McGePoint3d(
      this.m_stJoint.m_pt[0],
      this.m_stJoint.m_pt[1],
      this.m_stJoint.m_pt[2]
    );
    this.mcDbAxis.endPoint = new McGePoint3d(
      this.m_edJoint.m_pt[0],
      this.m_edJoint.m_pt[1],
      this.m_edJoint.m_pt[2]
    );
    // 节点数据绑定
    // if (this.m_stJoint) {
    //   if (!this.m_stJoint.m_AxisIds.includes(this.Guid)) {
    //     this.m_stJoint.m_AxisIds.push(this.Guid);
    //   }
    // }
    // if (this.m_edJoint) {
    //   if (!this.m_edJoint.m_AxisIds.includes(this.Guid)) {
    //     this.m_edJoint.m_AxisIds.push(this.Guid);
    //   }
    // }
    this.mcDbAxis.visible = false;
    // 将数据和图形绑定
    this.mcDbAxis.setxDataString("Guid", this.Guid);
    this.mcDbAxis.setxDataString("classTypeName", this.classTypeName);
    // this.mcDbAxis.visible = store.state.displayData.axisDisplay;
  }

  drawTextTest() {
    return;
    this.m_TextObj = new rlTextData();
    let position = new THREE.Vector3().lerpVectors(
      new THREE.Vector3(...this.m_stJoint.m_pt),
      new THREE.Vector3(...this.m_edJoint.m_pt),
      0.5
    );
    position.x -= 120;
    position.y -= 120;
    this.m_TextObj.position = position;
    // new THREE.Vector3(...this.m_pt);
    this.m_TextObj.Text = this.Guid.slice(-5);
    this.m_TextObj.textType = "测试轴线";
    this.m_TextObj.draw(true);
    this.m_TextObj.lineObjId = this.m_TextObj.mcDbId;
  }
  // 节点变化时轴线相应更新
  async updateData(jointObj) {
    if (this.m_gridIds && this.m_gridIds.length > 0) {
      // 删除端点后，若轴线上还存在网格，轴线的端点改变
      // 将轴线上的点都提取出来，都点排序，取首尾两点
      const isChangeStart = this.m_stJoint.Guid == jointObj.Guid;

      const axisPt = isChangeStart
        ? new THREE.Vector3(...this.m_edJoint.m_pt)
        : new THREE.Vector3(...this.m_stJoint.m_pt);
      const sortJointData = {};
      for (let i = 0; i < this.m_gridIds.length; i++) {
        const gridId = this.m_gridIds[i];

        const objGrid = getEntityData({
          classTypeName: "rlGrid",
          Guid: gridId,
        });
        if (!objGrid) {
          delete this.m_gridIds[i];
        } else {
          const dist1 = new THREE.Vector3(...objGrid.m_stJoint.m_pt).distanceTo(
            axisPt
          );
          const dist2 = new THREE.Vector3(...objGrid.m_edJoint.m_pt).distanceTo(
            axisPt
          );
          if (dist1 > dist2) {
            sortJointData[dist1] = objGrid.m_stJoint;
          } else {
            sortJointData[dist2] = objGrid.m_edJoint;
          }
        }
      }

      if (sortJointData) {
        const lastKey = Object.keys(sortJointData).pop();
        if (isChangeStart) {
          this.m_stJoint = sortJointData[lastKey];
        } else {
          this.m_edJoint = sortJointData[lastKey];
        }
        if (this.m_stJoint.Guid == "" || this.m_edJoint.Guid == "") {
          console.log(
            "轴线关联节点为空------节点删除时关联轴线更新！！！！！！！！"
          );
        }
        await this.updateThisObj(this);
      }
    } else {
      // 否则，删除轴线
      await this.erase();
    }
  }

  // 数据修改更新
  updateThisObj(obj, isUpdateDisplay = true) {
    this.initData(obj);
    super.updateThisObj(obj);
    // 删除功能选择多个同时删除时需要及时处理关联关系
    // if (this.m_stJoint) {
    //   if (!this.m_stJoint.m_AxisIds.includes(this.Guid)) {
    //     this.m_stJoint.m_AxisIds.push(this.Guid);
    //   }
    // }
    // if (this.m_edJoint) {
    //   if (!this.m_edJoint.m_AxisIds.includes(this.Guid)) {
    //     this.m_edJoint.m_AxisIds.push(this.Guid);
    //   }
    // }
    if (this.m_stJoint.Guid == "" || this.m_edJoint.Guid == "") {
      console.log(
        "轴线关联节点为空------updateThisObj？？？？？？？？？？？？"
      );
    }
    //轴线绘制数据更新
    this.updateAxisName(this.Name);
    this.updateAxisDrawData();

    //测试代码
    this.m_TextObj?.erase();
    this.drawTextTest();
  }

  saveEditRevokeData() {
    //解除轴线与节点的关联
    // this.m_stJoint.m_AxisIds = this.m_stJoint.m_AxisIds.filter(
    //   (item) => item != this.Guid
    // );
    // this.m_edJoint.m_AxisIds = this.m_edJoint.m_AxisIds.filter(
    //   (item) => item != this.Guid
    // );
    super.saveEditRevokeData();
  }
  // 删除
  async erase() {
    //删除轴线上所有网格
    //撤销回退中不处理关联处理
    if (!store.state.globalData.isReDo) {
      if (this.m_gridIds && this.m_gridIds.length > 0) {
        //重新计算轴线的起点和终点
        let pointArray = [];
        for (let i = 0; i < this.m_gridIds.length; i++) {
          const gridId = this.m_gridIds[i];
          const objGrid = getEntityData({
            classTypeName: "rlGrid",
            Guid: gridId,
          });
          if (objGrid) {
            pointArray.push({
              pt: objGrid.m_stJoint.m_pt,
              obj: objGrid.m_stJoint,
            });
            pointArray.push({
              pt: objGrid.m_edJoint.m_pt,
              obj: objGrid.m_edJoint,
            });
          }
        }
        pointArray.sort((a, b) => {
          if (a.pt[0] !== b.pt[0]) return a.pt[0] - b.pt[0];
          if (a.pt[1] !== b.pt[1]) return a.pt[1] - b.pt[1];
          return a.pt[2] - b.pt[2];
        });

        if (this.m_stJoint.Guid !== pointArray[0].obj) {
          //删除节点
          this.m_stJoint.erase();
        }
        if (this.m_edJoint.Guid !== pointArray[pointArray.length - 1].obj) {
          //删除节点
          this.m_edJoint.erase();
        }
        this.m_stJoint = pointArray[0].obj;
        this.m_edJoint = pointArray[pointArray.length - 1].obj;
        this.updateThisObj(this);

        return;
      }
      // for (let item in this.m_gridIds) {
      //   let objGrid = getEntityData({
      //     classTypeName: "rlGrid",
      //     Guid: item,
      //   });
      //   if (objGrid) {
      //     await objGrid.erase();
      //   }
      // }
    }

    if (this.m_stJoint) {
      // if (this.m_stJoint.m_AxisIds.includes(this.Guid)) {
      //   this.m_stJoint.m_AxisIds = this.m_stJoint.m_AxisIds.filter(
      //     (item) => item != this.Guid
      //   );
      //   //
      // }
      //撤销回退中不处理关联处理
      if (!store.state.globalData.isReDo) {
        // if (
        //   this.m_stJoint.m_AxisIds.length == 0 &&
        //   this.m_stJoint.m_gridIds.length == 0
        // ) {
        await this.m_stJoint.erase();
        // }
      }
    }

    if (this.m_edJoint) {
      // if (this.m_edJoint.m_AxisIds.includes(this.Guid)) {
      //   this.m_edJoint.m_AxisIds = this.m_edJoint.m_AxisIds.filter(
      //     (item) => item != this.Guid
      //   );
      //   //
      // }
      //撤销回退中不处理关联处理
      if (!store.state.globalData.isReDo) {
        // if (
        //   this.m_edJoint.m_AxisIds.length == 0 &&
        //   this.m_edJoint.m_gridIds.length == 0
        // ) {
        await this.m_edJoint.erase();
        // }
      }
    }

    this.m_stText?.erase();
    this.m_edText?.erase();
    this.m_stCircle?.erase();
    this.m_edCircle?.erase();
    this.m_stLineTmp?.erase();
    this.m_edLineTmp?.erase();
    // this.m_stLineTmpId && this.m_stLineTmpId?.getMcDbEntity().erase();
    // this.m_edLineTmpId && this.m_edLineTmpId?.getMcDbEntity().erase();
    // this.m_stCircleId && this.m_stCircleId?.getMcDbEntity().erase();
    // this.m_edCircleId && this.m_edCircleId?.getMcDbEntity().erase();

    store.commit("globalData/deleteGuidToRlAxisLineLoad", this.Guid);
    this.mcDbAxis?.erase();
    this.mcDbId?.getMcDbEntity().erase();
    await super.erase();
    this.m_TextObj?.erase();
  }

  // 返回图形源数据
  getDataBase() {
    const data = super.getDataBase();

    if (this.m_stJoint && this.m_stJoint.Guid != "")
      data["Jt1Guid"] = this.m_stJoint.Guid;

    if (this.m_edJoint && this.m_edJoint.Guid != "")
      data["Jt2Guid"] = this.m_edJoint.Guid;
    data["Name"] = this.Name;
    data["IsMainAxis"] = this.IsMainAxis;
    data["IsShow"] = this.isShow;
    return data;
  }

  getDrawData() {
    const data = super.getDrawData();

    data["m_stJoint"] = this.m_stJoint.Guid;
    data["m_edJoint"] = this.m_edJoint.Guid;

    data["Name"] = this.Name;
    data["IsMainAxis"] = this.IsMainAxis;
    data["m_gridIds"] = this.m_gridIds;
    // data["m_stText"] = this.m_stText.objectId();
    // data["m_edText"] = this.m_edText.objectId();
    // data["m_stLineTmp"] = this.m_stLineTmp.objectId();
    // data["m_edLineTmp"] = this.m_edLineTmp.objectId();
    // data["m_stCircle"] = this.m_stCircle.objectId();
    // data["m_edCircle"] = this.m_edCircle.objectId();
    return data;
  }

  // 移动
  transformBy(_mat) {
    // this.points.forEach(item => item.add(_mat))
    // this.setNeedUpdateDisplay(true);
  }

  //新画线输入--预览效果
  drawLineByPointsPreview(straightLineSimulate, ptOrigin) {
    //打开鼠标捕捉
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: true,
    });
    return new Promise((resolve, reject) => {
      // 实例化取点对象
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      getPoint.clearLastInputPoint();
      // 鼠标第一次点击
      if (!ptOrigin) {
        // 关闭正交模式
        fixOrthogonal(false);
        getPoint.go((status) => {
          if (status === -1 || status !== 0 || !straightLineSimulate) {
            window.canvas
              .getContext("2d")
              .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识
            this.points = []; // 清空点数组
            return resolve();
          }

          store.commit("drawModules/setDrawPlay", true);
          setTimeout(() => {
            // 开启正交模式
            fixOrthogonal(true);
            // 当前鼠标位置
            let pt1 = store.state.cadModules.snapPoint.snapPoint; //getPoint.value();
            store.commit("cadModules/setSnapPoint", {
              snapPoint: pt1,
              needCatchSnap: false,
            });
            // //设置捕捉优化
            if (!pt1) {
              pt1 = getPoint.value();
              let snapPoint = enableSnapCorrection(pt1);
              pt1 = snapPoint ? snapPoint : pt1;
            }
            let res = this.drawLineUserDraw(
              getPoint,
              pt1,
              straightLineSimulate
            );
            resolve(res);
            getPoint.clearLastInputPoint();
            store.commit("drawModules/setDrawPlay", false);
          }, 0);
        });
      } else {
        setTimeout(() => {
          fixOrthogonal(true);
          let res = this.drawLineUserDraw(
            getPoint,
            ptOrigin,
            straightLineSimulate
          );
          resolve(res);
          getPoint.clearLastInputPoint();
          store.commit("drawModules/setDrawPlay", false);
        }, 0);
      }
    }).catch((error) => {
      console.log("roor-drawLineByPointsPreview", error);
    });
  }

  drawLineUserDraw(getPoint, pt1, straightLineSimulate) {
    let modulusDistance = 0; // 模数距离
    let textSize = null; // 文本大小
    let angle = 0; // 角度
    let midPoint = null; // 中点
    let endPointLabelPosition = null; // 终点文本位置
    let offset = 0; // 偏移量
    let angleValue = 0; // 角度值
    if (store.state.app.singleFinger === false) {
      return new Promise((resolve) => {
        this.points = [];
        return resolve({});
      });
    }
    getPoint.setBasePt(pt1);
    // 保存初始点
    this.points.push(pt1);

    return new Promise((resolve, reject) => {
      let inputElement = getInputElement();
      if (!inputElement) {
        inputElement = createInputElement(this, true);
      } else if (inputElement.style.display == "none") {
        setCurrDataObj(this);
        // inputElement.style.display = "block";
        setContainerShow(true);
      }

      inputElement.readOnly = true;

      getPoint.setUserDraw((currentPoint, pWorldDraw) => {
        // 获取当前视区的显示范围
        const viewDocCoord =
          rlAppObj._rlMx.MxFun.getCurrentDraw().getViewDocCoord();

        // 开启正交模式并设置点
        fixOrthogonal(true);

        const isOrthogonal = store.state.platBtns.isOrthogonal;
        //当开启正交的时候,纠正偏移,正交有bug,没办法,只能来硬的了
        if (isOrthogonal) {
          // 在需要判断方向的地方使用:
          let direction = new THREE.Vector3()
            .subVectors(pt1, currentPoint)
            .normalize();
          if (Math.abs(direction.x) > Math.abs(direction.y)) {
            // 更偏向于X轴的处理
            currentPoint.y = pt1.y;
          } else {
            // 更偏向于Y轴的处理
            currentPoint.x = pt1.x;
          }
        }

        let snapPoint = enableSnapCorrection(currentPoint, pt1);
        currentPoint = snapPoint ? snapPoint : currentPoint;
        this.setPoints(pt1, currentPoint);

        if (this.points.length >= 2) {
          const startPoint = pt1;
          const endPoint = currentPoint.clone();
          const distance = startPoint.distanceTo(endPoint);

          // 如果在移动设备上并且距离小于等于5，不显示任何内容
          if (isMobileDevice() && distance <= 5) {
            // 清除所有绘制内容和输入框
            if (typeof pWorldDraw.clear === "function") {
              pWorldDraw.clear();
            }
            // 清空输入框中的内容并隐藏
            if (inputElement) {
              inputElement.value = "";
              setContainerShow(false);
            }
            return;
          }

          // 调整距离到模数，四舍五入
          modulusDistance =
            Math.round(distance / straightLineSimulate) * straightLineSimulate;

          endPoint
            .sub(startPoint)
            .normalize()
            .multiplyScalar(modulusDistance)
            .add(startPoint);
          this.setPoints(startPoint, endPoint);

          // 计算角度
          angle = Math.atan2(
            endPoint.y - startPoint.y,
            endPoint.x - startPoint.x
          );
          angleValue = ((angle * 180) / Math.PI + 360) % 360;

          // 修正角度在左右侧的显示
          if (angle > Math.PI / 2 || angle < -Math.PI / 2) {
            angle -= Math.PI;
          }

          // 根据视区范围调整文本大小
          const viewWidth = Math.abs(viewDocCoord.pt3.x - viewDocCoord.pt1.x);
          const referenceSize = 1000;
          textSize = 10 * (viewWidth / referenceSize);

          // 计算中点位置用于显示距离
          midPoint = new THREE.Vector3().lerpVectors(startPoint, endPoint, 0.5);
          // offset = textSize * 0.5;
          // adjustLabelPosition(midPoint, angle, offset);

          // // 计算角度显示位置
          // endPointLabelPosition = endPoint.clone();
          // adjustLabelPosition(endPointLabelPosition, angle, offset, true);

          // 显示输入元素及文本
          setContainerShow(true);
          setInputElementPosition(
            modulusDistance.toFixed(0),
            midPoint.x,
            midPoint.y
          );
          // // 绘制距离和角度文本
          // pWorldDraw.setColor(0xff0000);
          // pWorldDraw.drawText(
          //   modulusDistance.toFixed(0),
          //   textSize,
          //   angle,
          //   midPoint
          // );
          // pWorldDraw.drawText(
          //   (angleValue === 360 ? 0 : angleValue).toFixed(1) + "°",
          //   textSize,
          //   angle,
          //   endPointLabelPosition
          // );
          // pWorldDraw.drawLine(startPoint, endPoint);
        }
      });

      // // 调整标签位置
      // function adjustLabelPosition(point, angle, offset, isEndPoint = false) {
      //   const extraOffset = isEndPoint ? offset : 0; // 终点增加额外间距
      //   if (
      //     Math.abs(angle) < Math.PI / 6 ||
      //     Math.abs(angle) > (5 * Math.PI) / 6
      //   ) {
      //     point.y -= offset + extraOffset;
      //   } else {
      //     point.x -= (offset + extraOffset) * Math.sign(Math.cos(angle));
      //   }
      // }

      // 设置触摸事件
      getPoint.setInputToucheType(2);
      getPoint.go((status2) => {
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识

        inputElement.readOnly = false;
        // 鼠标右键结束绘制
        if (status2 !== 0) {
          // 右键取消时清空点数组
          // this.points = [];
          return resolve();
        }

        // 如果只有一个点或没有点，就直接返回
        if (this.points.length <= 1) {
          this.points = [];
          // 返回一个空对象，表示需要继续绘制
          return resolve({});
        }

        // 检查最终的两点之间的距离，确保大于500才绘制（仅移动设备）
        const finalDistance = this.points[0].distanceTo(this.points[1]);

        if (isMobileDevice() && finalDistance <= 5) {
          // 如果在移动设备上并且最终距离小于等于5，不创建轴线，并清空点数组
          this.points = [];
          // 返回一个空对象，表示需要继续绘制
          return resolve({});
        }

        this.mcDbAxis.startPoint = new McGePoint3d(
          this.points[0].x,
          this.points[0].y,
          this.points[0].z
        );

        this.mcDbAxis.endPoint = new McGePoint3d(
          this.points[1].x,
          this.points[1].y,
          this.points[1].z
        );

        // let numVerts = this.mcDbAxis.numVerts() - 1;
        // for (let i = numVerts; i >= 0; i--) {
        //   this.mcDbAxis.removeVertexAt(i);
        // }
        // this.mcDbAxis.addVertexAt(this.mcDbAxis.startPoint);
        // this.mcDbAxis.addVertexAt(this.mcDbAxis.endPoint);
        this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbAxis);
        resolve(this);
      });
    }).catch((e) => {
      console.log("eeee", e);
    });
  }

  // 画线(模数录入)
  drawLineByPoints(straightLineSimulate) {
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: true,
    });
    return new Promise((resolve, reject) => {
      // 实例化取点对象
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      getPoint.clearLastInputPoint();
      // 关闭正交模式
      fixOrthogonal(false);

      let modulusDistance = 0; // 模数距离
      let textSize = null; // 文本大小
      let angle = 0; // 角度
      let midPoint = null; // 中点
      let endPointLabelPosition = null; // 终点文本位置
      let offset = 0; // 偏移量
      let angleValue = 0; // 角度值

      // 设置触摸事件
      // getPoint.setInputToucheType(1);

      // 鼠标第一次点击
      getPoint.go((status) => {
        if (status === -1 || status !== 0 || !straightLineSimulate) {
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识
          return resolve();
        }

        store.commit("drawModules/setDrawPlay", true);
        // 开启正交模式
        fixOrthogonal(true);

        // 当前鼠标位置
        let pt1 = store.state.cadModules.snapPoint.snapPoint; //getPoint.value();
        store.commit("cadModules/setSnapPoint", {
          snapPoint: pt1,
          needCatchSnap: false,
        });
        // //设置捕捉优化
        if (!pt1) {
          pt1 = getPoint.value();
          let snapPoint = enableSnapCorrection(pt1);
          pt1 = snapPoint ? snapPoint : pt1;
        }
        getPoint.setBasePt(pt1);

        // 保存初始点
        this.points.push(pt1);
        getPoint.setUserDraw((currentPoint, pWorldDraw) => {
          // 获取当前视区的显示范围
          const viewDocCoord =
            rlAppObj._rlMx.MxFun.getCurrentDraw().getViewDocCoord();

          // 开启正交模式并设置点
          fixOrthogonal(true);

          let snapPoint = enableSnapCorrection(currentPoint, pt1);
          currentPoint = snapPoint ? snapPoint : currentPoint;
          this.setPoints(pt1, currentPoint);

          if (this.points.length >= 2) {
            const startPoint = pt1;
            const endPoint = currentPoint.clone();
            const distance = startPoint.distanceTo(endPoint);

            // 调整距离到模数的最近整数倍
            modulusDistance =
              Math.ceil(distance / straightLineSimulate) * straightLineSimulate;
            endPoint
              .sub(startPoint)
              .normalize()
              .multiplyScalar(modulusDistance)
              .add(startPoint);
            this.setPoints(startPoint, endPoint);

            // 计算角度
            angle = Math.atan2(
              endPoint.y - startPoint.y,
              endPoint.x - startPoint.x
            );
            angleValue = ((angle * 180) / Math.PI + 360) % 360;

            // 修正角度在左右侧的显示
            if (angle > Math.PI / 2 || angle < -Math.PI / 2) {
              angle -= Math.PI;
            }

            // 根据视区范围调整文本大小
            const viewWidth = Math.abs(viewDocCoord.pt3.x - viewDocCoord.pt1.x);
            const referenceSize = 1000;
            textSize = 10 * (viewWidth / referenceSize);

            // 计算中点位置用于显示距离
            midPoint = new THREE.Vector3().lerpVectors(
              startPoint,
              endPoint,
              0.5
            );
            offset = textSize * 0.5;
            adjustLabelPosition(midPoint, angle, offset);

            // 计算角度显示位置
            endPointLabelPosition = endPoint.clone();
            adjustLabelPosition(endPointLabelPosition, angle, offset, true);

            // 绘制距离和角度文本
            pWorldDraw.setColor(0xff0000);
            pWorldDraw.drawText(
              modulusDistance.toFixed(0),
              textSize,
              angle,
              midPoint
            );
            pWorldDraw.drawText(
              (angleValue === 360 ? 0 : angleValue).toFixed(1) + "°",
              textSize,
              angle,
              endPointLabelPosition
            );
            // pWorldDraw.drawLine(startPoint, endPoint);
          }
        });

        // 调整标签位置
        function adjustLabelPosition(point, angle, offset, isEndPoint = false) {
          const extraOffset = isEndPoint ? offset : 0; // 终点增加额外间距
          if (
            Math.abs(angle) < Math.PI / 6 ||
            Math.abs(angle) > (5 * Math.PI) / 6
          ) {
            point.y -= offset + extraOffset;
          } else {
            point.x -= (offset + extraOffset) * Math.sign(Math.cos(angle));
          }
        }

        // 设置触摸事件
        getPoint.setInputToucheType(2);
        getPoint.go((status2) => {
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识

          // 鼠标右键结束绘制
          if (status2 !== 0) return resolve();

          // 预留
          // if (false) {
          //   // 计算文字偏移位置
          //   adjustLabelPosition(midPoint, angle, offset);
          //   adjustLabelPosition(endPointLabelPosition, angle, offset, true);
          //   // 在这里创建文本
          //   const textDistance = new McDbText();
          //   textDistance.horizontalMode = 5;
          //   textDistance.verticalMode = 3;
          //   textDistance.textString = modulusDistance.toFixed(0);
          //   textDistance.position = textDistance.alignmentPoint =
          //     new McGePoint3d(midPoint.x, midPoint.y, 0);
          //   textDistance.rotation = angle;
          //   textDistance.trueColor = new McCmColor(255, 0, 0);
          //   textDistance.height = textSize * 0.6;
          //   this.textDistanceId = rlAppObj.mxcadObject.drawEntity(textDistance);

          //   const textAngle = new McDbText();
          //   textAngle.horizontalMode = 1;
          //   textAngle.verticalMode = 3;[p]
          //   textAngle.textString = (
          //     angleValue === 360 ? 0 : angleValue
          //   ).toFixed(1);
          //   textAngle.position = textAngle.alignmentPoint = new McGePoint3d(
          //     endPointLabelPosition.x,
          //     endPointLabelPosition.y,
          //     0
          //   );
          //   textAngle.rotation = angle;
          //   textAngle.trueColor = new McCmColor(255, 0, 0);
          //   textAngle.height = textSize * 0.6;
          //   this.textAngleId = rlAppObj.mxcadObject.drawEntity(textAngle);
          // }

          this.mcDbAxis.startPoint = new McGePoint3d(
            this.points[0].x,
            this.points[0].y,
            this.points[0].z
          );
          this.mcDbAxis.endPoint = new McGePoint3d(
            this.points[1].x,
            this.points[1].y,
            this.points[1].z
          );
          // let numVerts = this.mcDbAxis.numVerts() - 1;
          // for (let i = numVerts; i >= 0; i--) {
          //   this.mcDbAxis.removeVertexAt(i);
          // }
          // this.mcDbAxis.addVertexAt(this.mcDbAxis.startPoint);
          // this.mcDbAxis.addVertexAt(this.mcDbAxis.endPoint);
          resolve(this);
        });
      });
      getPoint.clearLastInputPoint();
      store.commit("drawModules/setDrawPlay", false);
    });
  }

  async copyAxisData(vecMove) {
    // 对位移向量进行精度处理，减少累积误差
    const roundedVecMove = new THREE.Vector3(
      Math.round(vecMove.x * 10000) / 10000,
      Math.round(vecMove.y * 10000) / 10000,
      Math.round(vecMove.z * 10000) / 10000
    );

    const sPt = new THREE.Vector3(...this.m_stJoint.m_pt).add(roundedVecMove);
    const ePt = new THREE.Vector3(...this.m_edJoint.m_pt).add(roundedVecMove);

    // 对坐标进行更高精度的四舍五入，减少精度损失
    sPt.x = Math.round(sPt.x * 10000) / 10000;
    sPt.y = Math.round(sPt.y * 10000) / 10000;
    sPt.z = Math.round(sPt.z * 10000) / 10000;

    ePt.x = Math.round(ePt.x * 10000) / 10000;
    ePt.y = Math.round(ePt.y * 10000) / 10000;
    ePt.z = Math.round(ePt.z * 10000) / 10000;

    // 检查并强制正交
    const originalVector = new THREE.Vector3().subVectors(
      new THREE.Vector3(...this.m_edJoint.m_pt),
      new THREE.Vector3(...this.m_stJoint.m_pt)
    );

    // 计算原始轴线的角度
    const originalAngle = Math.atan2(originalVector.y, originalVector.x);

    // 检查是否接近正交（允许0.1度的误差）
    const isOrthogonal =
      Math.abs(Math.abs(originalAngle) - Math.PI / 2) < 0.001 ||
      Math.abs(originalAngle) < 0.001 ||
      Math.abs(Math.abs(originalAngle) - Math.PI) < 0.001;

    // 如果是正交的，确保复制后的轴线也保持正交
    if (isOrthogonal) {
      // 计算复制后轴线的向量
      const newVector = new THREE.Vector3().subVectors(ePt, sPt);

      // 计算新向量的角度
      const newAngle = Math.atan2(newVector.y, newVector.x);

      // 如果新角度不是正交的，强制修正
      if (
        Math.abs(Math.abs(newAngle) - Math.PI / 2) >= 0.001 &&
        Math.abs(newAngle) >= 0.001 &&
        Math.abs(Math.abs(newAngle) - Math.PI) >= 0.001
      ) {
        // 确定最接近的正交方向
        let targetAngle;
        if (Math.abs(newAngle) < Math.PI / 4) {
          targetAngle = 0; // 水平
        } else if (Math.abs(newAngle - Math.PI / 2) < Math.PI / 4) {
          targetAngle = Math.PI / 2; // 垂直
        } else if (Math.abs(newAngle - Math.PI) < Math.PI / 4) {
          targetAngle = Math.PI; // 水平反向
        } else {
          targetAngle = -Math.PI / 2; // 垂直反向
        }

        // 计算向量长度
        const length = newVector.length();

        // 根据目标角度重新计算终点
        ePt.x = sPt.x + length * Math.cos(targetAngle);
        ePt.y = sPt.y + length * Math.sin(targetAngle);

        // 再次进行精度处理
        ePt.x = Math.round(ePt.x * 10000) / 10000;
        ePt.y = Math.round(ePt.y * 10000) / 10000;
      }
    }

    // 创建新的节点
    let newStJoint = new rlJointData();
    newStJoint.initData({ m_pt: [sPt.x, sPt.y, sPt.z] });

    let newEdJoint = new rlJointData();
    newEdJoint.initData({ m_pt: [ePt.x, ePt.y, ePt.z] });

    // 返回已存在的节点对象
    const isEditSP = await addEntityToDrawing(newStJoint, false);
    const isEditEP = await addEntityToDrawing(newEdJoint, false);

    // 判断移动后的网格位置上是否存在轴线，若没有，新增轴线，内部已实现重复校验
    let axisObj = new rlAxisData();
    axisObj.initData({
      m_stJoint: isEditSP || newStJoint,
      m_edJoint: isEditEP || newEdJoint,
    });

    let isExistAxis = await addEntityToDrawing(axisObj, false);
    if (isExistAxis) axisObj = isExistAxis;

    // 创建一个新的rlGridData对象，并初始化数据
    const objGrid = new rlGridData();
    objGrid.initData({
      m_stJoint: isEditSP || newStJoint,
      m_edJoint: isEditEP || newEdJoint,
      m_Axis: axisObj,
    });

    // 将网格对象添加到绘图中
    await addEntityToDrawing(objGrid, false);

    return axisObj;
  }

  // 计算轴线命名数据
  calAxisNameData = (isVisible) => {
    if (isVisible == undefined) {
      isVisible = store.state.displayData.axisDisplay;
    }
    if (this.isShow == "0") isVisible = false;

    // 判断是否已经加载过轴线命名数据
    if (!store.state.globalData.rlAxisLineLoad.includes(this.Guid)) {
      store.commit("globalData/addGuidToRlAxisLineLoad", this.Guid);
      this.m_axisLineStPt = this.m_axisLineStPt
        ? this.m_axisLineStPt
        : new THREE.Vector3(
            this.m_stJoint.m_pt[0],
            this.m_stJoint.m_pt[1],
            this.m_stJoint.m_pt[2]
          );
      this.m_axisLineEdPt = this.m_axisLineEdPt
        ? this.m_axisLineEdPt
        : new THREE.Vector3(
            this.m_edJoint.m_pt[0],
            this.m_edJoint.m_pt[1],
            this.m_edJoint.m_pt[2]
          );

      // 轴线命名的显示隐藏
      // this.mcDbId.getMcDbEntity().visible = isVisible;
      // 计算直线的方向
      const stPos = this.m_axisLineStPt;
      const edPos = this.m_axisLineEdPt;

      const lineOrigin = new THREE.Line3(stPos, edPos);
      const vecDir = new THREE.Vector3();
      lineOrigin.delta(vecDir);
      vecDir.normalize();

      // 绘制轴线命名辅助直线
      const stExternLinePos = new THREE.Vector3(
        stPos.x - vecDir.x * 3000,
        stPos.y - vecDir.y * 3000,
        stPos.z
      );
      //虚线样式

      const mxcad = MxCpp.getCurrentMxCAD();
      const axisLineLayer = mxcad.addLayer("轴线");
      const axisNoLayer = mxcad.addLayer("轴号");
      this.m_stLineTmp = new rlLineData();
      this.m_stLineTmp.McDbLine.trueColor = new McCmColor(150, 5, 80);
      this.m_stLineTmp.stPt = new McGePoint3d(stPos.x, stPos.y, stPos.z);
      this.m_stLineTmp.edPt = new McGePoint3d(
        stExternLinePos.x,
        stExternLinePos.y,
        stExternLinePos.z
      );
      this.m_stLineTmp.draw(isVisible, true);
      this.m_stLineTmp.mcDbId.getMcDbEntity().layerId = axisLineLayer;
      // 绘制轴线命名辅助直线
      const edExternLinePos = new THREE.Vector3(
        edPos.x + vecDir.x * 3000,
        edPos.y + vecDir.y * 3000,
        edPos.z
      );

      this.m_edLineTmp = new rlLineData();
      this.m_edLineTmp.McDbLine.trueColor = new McCmColor(150, 5, 80);
      this.m_edLineTmp.stPt = new McGePoint3d(edPos.x, edPos.y, edPos.z);
      this.m_edLineTmp.edPt = new McGePoint3d(
        edExternLinePos.x,
        edExternLinePos.y,
        edExternLinePos.z
      );
      this.m_edLineTmp.draw(isVisible, true);
      this.m_edLineTmp.mcDbId.getMcDbEntity().layerId = axisLineLayer;
      const radius = store.state.platBtns.fontSize;
      // 绘制两端包围文字的圆
      const stExternPos = new THREE.Vector3(
        stPos.x - vecDir.x * (radius + 3000),
        stPos.y - vecDir.y * (radius + 3000),
        stPos.z
      );

      this.m_stCircle = new rlCircleData();
      this.m_stCircle.ptCenter = new THREE.Vector3(
        stExternPos.x,
        stExternPos.y,
        stExternPos.z
      );
      this.m_stCircle.Radius = radius;
      this.m_stCircle.draw(isVisible);
      this.m_stCircle.mcDbId.getMcDbEntity().layerId = axisNoLayer;
      rlAppObj.rlMxDrawObject.updateDisplay();

      const edExternPos = new THREE.Vector3(
        edPos.x + vecDir.x * (radius + 3000),
        edPos.y + vecDir.y * (radius + 3000),
        edPos.z
      );
      this.m_edCircle = new rlCircleData();
      this.m_edCircle.ptCenter = new THREE.Vector3(
        edExternPos.x,
        edExternPos.y,
        edExternPos.z
      );
      this.m_edCircle.Radius = radius;
      this.m_edCircle.draw(isVisible);
      this.m_edCircle.mcDbId.getMcDbEntity().layerId = axisNoLayer;
      // 绘制两端轴线名称
      this.m_stText = new rlTextData();
      this.m_stText.position = stExternPos;
      this.m_stText.Text = this.Name;
      this.m_stText.textType = "轴号";
      this.m_stText.draw(isVisible);
      this.m_stText.lineObjId = this.m_stText.mcDbId;
      this.m_stText.mcDbId.getMcDbEntity().layerId = axisNoLayer;
      this.m_edText = new rlTextData();
      this.m_edText.position = edExternPos;
      this.m_edText.Text = this.Name;
      this.m_edText.McDbText.visible = isVisible;
      this.m_edText.textType = "轴号";
      this.m_edText.draw(isVisible);
      this.m_edText.lineObjId = this.m_edText.mcDbId;
      this.m_edText.mcDbId.getMcDbEntity().layerId = axisNoLayer;
    } else {
      this.showAxisName(isVisible);
    }
  };

  updateAxisName(Text) {
    this.Name = String(Text);

    if (this.m_stText.mcDbId) {
      this.m_stText.Text = String(Text);
      this.m_stText.mcDbId.getMcDbEntity().textString = String(Text);
    }

    // this.m_stText.setNeedUpdateDisplay(true);
    if (this.m_edText.mcDbId) {
      this.m_edText.Text = String(Text);
      this.m_edText.mcDbId.getMcDbEntity().textString = String(Text);
    }
  }

  //轴线长度修改后，更新轴线命名数据
  updateAxisDrawData(LineStPt = null, LineEdPt = null) {
    if (LineStPt) this.m_axisLineStPt = LineStPt;
    else if (!this.m_axisLineStPt) {
      this.m_axisLineStPt = new THREE.Vector3(
        this.m_stJoint.m_pt[0],
        this.m_stJoint.m_pt[1],
        this.m_stJoint.m_pt[2]
      );
    }

    if (LineEdPt) this.m_axisLineEdPt = LineEdPt;
    else if (!this.m_axisLineEdPt) {
      this.m_axisLineEdPt = new THREE.Vector3(
        this.m_edJoint.m_pt[0],
        this.m_edJoint.m_pt[1],
        this.m_edJoint.m_pt[2]
      );
    }

    // 计算直线的方向
    const stPos = this.m_axisLineStPt;
    const edPos = this.m_axisLineEdPt;
    const lineOrigin = new THREE.Line3(stPos, edPos);
    const vecDir = new THREE.Vector3();
    lineOrigin.delta(vecDir);
    vecDir.normalize();

    // 绘制轴线命名辅助直线
    const stExternLinePos = new THREE.Vector3(
      stPos.x - vecDir.x * 3000,
      stPos.y - vecDir.y * 3000,
      stPos.z
    );

    if (this.m_stLineTmp.mcDbId) {
      this.m_stLineTmp.mcDbId.getMcDbEntity().startPoint = new McGePoint3d(
        this.m_stJoint.m_pt[0],
        this.m_stJoint.m_pt[1],
        this.m_stJoint.m_pt[2]
      );
      this.m_stLineTmp.mcDbId.getMcDbEntity().endPoint = new McGePoint3d(
        stExternLinePos.x,
        stExternLinePos.y,
        stExternLinePos.z
      );
    }

    // 绘制轴线命名辅助直线
    const edExternLinePos = new THREE.Vector3(
      edPos.x + vecDir.x * 3000,
      edPos.y + vecDir.y * 3000,
      edPos.z
    );
    if (this.m_edLineTmp.mcDbId) {
      this.m_edLineTmp.mcDbId.getMcDbEntity().startPoint = new McGePoint3d(
        this.m_edJoint.m_pt[0],
        this.m_edJoint.m_pt[1],
        this.m_edJoint.m_pt[2]
      );
      this.m_edLineTmp.mcDbId.getMcDbEntity().endPoint = new McGePoint3d(
        edExternLinePos.x,
        edExternLinePos.y,
        edExternLinePos.z
      );
    }
    const radius = store.state.platBtns.fontSize + 3000;
    // 绘制两端包围文字的圆
    const stExternPos = new THREE.Vector3(
      stPos.x - vecDir.x * radius,
      stPos.y - vecDir.y * radius,
      stPos.z
    );

    if (this.m_stCircle.mcDbId) {
      this.m_stCircle.mcDbId.getMcDbEntity().center = new McGePoint3d(
        stExternPos.x,
        stExternPos.y,
        stExternPos.z
      );
      // this.m_stCircle.mcDbId.getMcDbEntity().radius = radius;
    }

    const edExternPos = new THREE.Vector3(
      edPos.x + vecDir.x * radius,
      edPos.y + vecDir.y * radius,
      edPos.z
    );

    if (this.m_edCircle.mcDbId) {
      this.m_edCircle.mcDbId.getMcDbEntity().center = new McGePoint3d(
        edExternPos.x,
        edExternPos.y,
        edExternPos.z
      );
      // this.m_edCircle.mcDbId.getMcDbEntity().radius = radius;
    }

    // 绘制两端轴线名称
    if (this.m_stText.mcDbId) {
      let position = new McGePoint3d(
        stExternPos.x,
        stExternPos.y,
        stExternPos.z
      );
      this.m_stText.position = position;
      let textObj = this.m_stText.mcDbId.getMcDbEntity();
      textObj.alignmentPoint = textObj.position = position;
    }
    if (this.m_edText.mcDbId) {
      let position = new McGePoint3d(
        edExternPos.x,
        edExternPos.y,
        edExternPos.z
      );
      this.m_edText.position = position;
      let textObj = this.m_edText.mcDbId.getMcDbEntity();
      textObj.alignmentPoint = textObj.position = position;
    }
  }
  // 轴线命名的显示隐藏
  showAxisName(isShow) {
    if (
      this.mcDbId &&
      this.m_stText &&
      this.m_edText &&
      this.m_stLineTmp &&
      this.m_edLineTmp &&
      this.m_stCircle &&
      this.m_edCircle
    ) {
      let showAxis = isShow;
      if (this.isShow == "0") {
        showAxis = false;
      }
      // this.mcDbId.getMcDbEntity().visible = showAxis;
      if (this.m_stText.mcDbId) {
        this.m_stText.mcDbId.getMcDbEntity().visible = showAxis;
        // this.m_stText.setNeedUpdateDisplay(true);
      }

      if (this.m_edText.mcDbId) {
        this.m_edText.mcDbId.getMcDbEntity().visible = showAxis;
        // this.m_edText.setNeedUpdateDisplay(true);
      }

      if (this.m_stLineTmp.mcDbId) {
        this.m_stLineTmp.mcDbId.getMcDbEntity().visible = showAxis;
        //  this.m_stLineTmp.setNeedUpdateDisplay(true);
      }

      if (this.m_edLineTmp.mcDbId) {
        this.m_edLineTmp.mcDbId.getMcDbEntity().visible = showAxis;
        //  this.m_edLineTmp.setNeedUpdateDisplay(true);
      }

      if (this.m_stCircle.mcDbId) {
        this.m_stCircle.mcDbId.getMcDbEntity().visible = showAxis;
        //  this.m_stCircle.setNeedUpdateDisplay(true);
      }

      if (this.m_edCircle.mcDbId) {
        this.m_edCircle.mcDbId.getMcDbEntity().visible = showAxis;
        //  this.m_edCircle.setNeedUpdateDisplay(true);
      }
      rlAppObj.rlMxDrawObject.updateDisplay();
    }
  }
}

export { rlAxisData };
